'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { LocaleCurrencyFormat } from '@/components/LocaleCurrencyFormat';
import { type CurrencyCode } from '@/modules/currencies/constants';
import {
  type SecondaryPrice,
  SecondaryPriceType,
} from '@/modules/price/aliases';

type Props = {
  secondaryPrice: SecondaryPrice;
};

export function SecondaryPriceLine({ secondaryPrice }: Props) {
  const tCommon = useTranslations('common');

  if (secondaryPrice.type === SecondaryPriceType.DynamicText) {
    if (!secondaryPrice.text) {
      return null;
    }

    return <Caption variant="lg-regular">{secondaryPrice.text}</Caption>;
  }

  const { price } = secondaryPrice;

  if (!price) {
    return null;
  }

  if (
    secondaryPrice.type === SecondaryPriceType.ShippingCost &&
    Number(price.amount) === 0
  ) {
    return (
      <Caption variant="lg-regular" className={styles.freeShipping}>
        {tCommon('ShippingFree')}
      </Caption>
    );
  }

  return (
    <Caption variant="lg-regular">
      {tCommon.rich('PlusShipping', {
        price: () => (
          <LocaleCurrencyFormat
            currencyCode={price.currency as CurrencyCode}
            numberToFormat={price.amount}
          />
        ),
      })}
    </Caption>
  );
}
